export default __webpack_public_path__ + "static/media/MenuFrame.75c850f3.svg";